import { createFileRoute, redirect } from "@tanstack/react-router";
import { E2eTestingPage } from "../../components/system/E2eTestingPage";
import { isE2eTestingAvailable } from "../../lib/auth/app-origins";
import { requireSuperAdmin } from "../../lib/auth/route-protection";

export const Route = createFileRoute("/system/e2e")({
  beforeLoad: () => {
    if (!isE2eTestingAvailable()) {
      throw redirect({ to: "/" });
    }
    requireSuperAdmin()();
  },
  component: E2eTestingRoute,
});

function E2eTestingRoute() {
  return <E2eTestingPage />;
}
